/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { BaseFormatTimestampArgs } from 'cio/components/format-timestamp';

export default class LongTimestamp extends Component<BaseFormatTimestampArgs> {
  @action
  finalFormatter(timestampAsMoment: moment.Moment) {
    return timestampAsMoment.calendar();
  }
}
